export type ChatDecisionItem = {
  num: number;
  responsible: string;
  text: string;
  deadline: string;
  deadline_iso?: string | null;
};

export type StructuredChatResponse = {
  intro: string;
  items: ChatDecisionItem[];
  sources: string[];
  urgent_count: number;
};

export function parseStructuredChatResponse(raw: string): StructuredChatResponse | null {
  if (!raw?.trim()) return null;
  try {
    const data = JSON.parse(raw.trim());
    if (!data || typeof data !== 'object') return null;
    const intro = String(data.intro || '').trim();
    const items = Array.isArray(data.items)
      ? data.items.map((item: Record<string, unknown>, idx: number) => ({
          num: Number(item.num) || idx + 1,
          responsible: String(item.responsible || '—').trim(),
          text: String(item.text || '').trim(),
          deadline: String(item.deadline || '—').trim(),
          deadline_iso: item.deadline_iso ? String(item.deadline_iso) : null,
        })).filter((i: ChatDecisionItem) => i.text)
      : [];
    const sources = Array.isArray(data.sources)
      ? data.sources.map((s: unknown) => String(s).trim()).filter(Boolean)
      : [];
    const urgent_count = Number(data.urgent_count) || 0;
    if (!intro && !items.length) return null;
    return { intro, items, sources, urgent_count };
  } catch {
    return null;
  }
}

const VAGUE_DEADLINE_RE =
  /постоянной основе|не определ|не указан|следующего совещания|без срока/i;

export function isKnownDeadline(deadline: string): boolean {
  const value = (deadline || '').trim();
  if (!value || value === '—' || value === '-') return false;
  if (VAGUE_DEADLINE_RE.test(value)) return false;
  return /\d{2}\.\d{2}\.\d{4}/.test(value);
}

export function isUrgentDeadline(deadline: string, deadlineIso?: string | null): boolean {
  if (!isKnownDeadline(deadline)) return false;
  let date: Date | null = null;
  if (deadlineIso) {
    const parsed = new Date(deadlineIso);
    if (!Number.isNaN(parsed.getTime())) date = parsed;
  }
  if (!date) {
    const m = deadline.match(/(\d{2})\.(\d{2})\.(\d{4})/);
    if (m) date = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  }
  if (!date || Number.isNaN(date.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(date);
  target.setHours(0, 0, 0, 0);
  const diffDays = (target.getTime() - today.getTime()) / 86400000;
  return diffDays >= 0 && diffDays <= 3;
}
